import React, { useEffect, useRef, useState } from "react";
import "../../styles/styles.css";
import "../../styles/SimpleQuizz/Simple_quiz.css";
import "../../styles/SimpleQuizz/DisplayFlower/Couronne.css";
import { DisplayQuestionnaire } from "./DisplayQuestionnaire";
import { OngletQuestion } from "./OngletQuestion";
import { QuizData } from "../../data/quizzData";
import { calculateAnswersNumber } from "../../data/utils";
import { sendQuizzResult } from "../utils/sendQuizzResult";
import { QuizzFinished } from "./QuizzFinished";
import Flower from "./DisplayFlower/Flower";

// Composant principal qui lance le quiz

const initialAnswers = QuizData.map((question) => ({
  questionId: question.id,
  level: null,
}));

export const SimpleQuiz = ({ email }) => {
  /*On ajoute un état qui sauvegarde les questions choisies */
  const [userAnswers, setUserAnswers] = useState(initialAnswers);

  /*On ajoute un état qui affiche la question traité en cours */
  const [questionId, setQuestionId] = useState(0);

  const [resultsSent, setResultsSent] = useState(false);
  const flowerRef = useRef();

  const quizzFinished = calculateAnswersNumber(userAnswers) === QuizData.length;

  useEffect(async () => {
    if (!quizzFinished) {
      return;
    }
    await sendQuizzResult(email, flowerRef);
    setResultsSent(true);
  }, [userAnswers]);

  return (
    <div>
      <OngletQuestion questionId={questionId} setProgression={setQuestionId} />
      <div className="container_body">
        {!quizzFinished ? (
          <DisplayQuestionnaire
            questionId={questionId}
            setQuestionId={setQuestionId}
            userAnswers={userAnswers}
            setUserAnswers={setUserAnswers}
            flowerRef={flowerRef}
          />
        ) : (
          <QuizzFinished flowerRef={flowerRef} resultsSent={resultsSent} />
        )}
        <Flower flowerRef={flowerRef} userAnswers={userAnswers} />
      </div>
    </div>
  );
};
